'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatTextdirectionRToL = function MdFormatTextdirectionRToL(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.4 28.4h20v3.2h-20v5l-6.8-6.6 6.8-6.6v5z m3.2-11.8q-2.7 0-4.6-1.9t-2-4.7 1.9-4.7 4.7-1.9h13.4v3.2h-3.4v18.4h-3.2v-18.4h-3.4v18.4h-3.4v-8.4z' })
        )
    );
};

exports.default = MdFormatTextdirectionRToL;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-textdirection-r-to-l.js
// module id = 2894
// module chunks = 0